import { render, staticRenderFns } from "./EntryList_CompletedSecondChance.vue?vue&type=template&id=5b87e8de&scoped=true"
import script from "./EntryList_CompletedSecondChance.vue?vue&type=script&lang=js"
export * from "./EntryList_CompletedSecondChance.vue?vue&type=script&lang=js"
import style0 from "./EntryList_CompletedSecondChance.vue?vue&type=style&index=0&id=5b87e8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b87e8de",
  null
  
)

export default component.exports